<template>
  <div>
    <Card>
        <p slot="title"> Giro </p>

        <Row type="flex" justify="space-between" class="code-row-bg">
            <Col span="12">
                <ButtonGroup class="custom-group-parent">
                    <Button class="custom-group">Marking</Button>
                    <Select
                        style="width: 250px;"
                        v-model="markingIdSelected"
                        filterable
                        clearable
                        :remote-method="getMarkingByCode"
                        :loading="isLoadingMarking"
                        @on-change="getReceivableGiro()" >
                        <Option v-for="option in optionMarkings"
                            :value="option.value" :key="option.value">{{option.label}}</Option>
                    </Select>
                </ButtonGroup>
            </Col>
            <Col span="12">
                <Spin size="large" v-show="isLoadingMarking"></Spin>
            </Col>
        </Row>

        <br/>

        <Card>
            <Table border :columns="columnsDataTable" :data="receivableGiroData"></Table>
        </Card>
    </Card>

    <Modal v-model="isModalAddGiro" width="500px">
        <p slot="header" style="color:#2d8cf0;text-align:center">
            <Icon type="information-circled"></Icon>
            <span>Tambah Giro</span>
        </p>
        <Form ref="formAddGiro" :model="formAddGiro" :rules="ruleValidateGiro">
            <Form-item label="Tanggal Invoice & No. Container" prop="invoiceDate">
                <Input v-model="formAddGiro.invoiceDateContainerNumber" disabled></Input>
                <Input style="display:none" v-model="formAddGiro.receivableId"></Input>
                <Input style="display:none" v-model="formAddGiro.markingHeaderId"></Input>
            </Form-item>
            <Form-item label="Tanggal Terima Giro" prop="giroDate">
                <Date-picker
                    placeholder="Tanggal Terima Giro"
                    style="width: 200px;display:revert;"
                    type="date"
                    format="yyyy-MM-dd"
                    v-model="formAddGiro.giroDate">
                </Date-picker>
            </Form-item>
            <Form-item label="Nomor Giro" prop="giroNumber">
                <Input v-model="formAddGiro.giroNumber" placeholder="Nomor Giro"></Input>
            </Form-item>
            <Form-item label="Nominal Giro" prop="giroNominal">
                <!-- <Input v-model="formAddGiro.giroNominal" placeholder="Nominal Giro"></Input> -->
                <br />
                <money
                    v-model="formAddGiro.giroNominal"
                    v-bind="money"
                    class="ivu-input right"
                    style="width: 150px;"></money>
            </Form-item>
            <Form-item label="Tanggal Jatuh Tempo" prop="paymentDate">
                <Date-picker
                    placeholder="Tanggal Jatuh Tempo"
                    style="width: 200px;display:revert;"
                    type="date"
                    format="yyyy-MM-dd"
                    v-model="formAddGiro.paymentDate">
                </Date-picker>
            </Form-item>
            <Form-item label="Bank" prop="bankAccountId">
                <br>
                <Select
                    style="width:80%;display:revert"
                    placeholder="Pilih Rekening Bank"
                    clearable
                    v-model="formAddGiro.bankAccountId">
                    <Option
                        v-for="bankAccount in bankAccounts"
                        :value="bankAccount.id"
                        :key="bankAccount.id">{{ bankAccount.accountName }}
                    </Option>
                </Select>
            </Form-item>
        </Form>
        <div slot="footer">
            <Button
                v-show="true"
                type="primary"
                :loading="isLoadingAddGiro"
                @click="postAddGiro" >
                <span v-if="!isLoadingAddGiro">Submit</span>
                <span v-else>On process.....</span>
            </Button>
        </div>
    </Modal>
  </div>
</template>

<script>
import {HTTP} from '@/components/http-lib'
import _ from 'lodash'
import moment from 'moment'
import {Money} from 'v-money'

const numeral = require('numeral');

export default {
    components : { Money },
    data () {
        return {
            optionMarkings : [],
            markingIdSelected : '',
            isLoadingMarking: false,
            money: {
              decimal: ',',
              thousands: '.',
              prefix: '',
              suffix: '',
              precision: 0,
              masked: false
            },
            columnsDataTable: [
                {
                    title: 'Tanggal Invoice',
                    key: 'invoiceDate'
                },
                {
                    title: 'No. Container',
                    key: 'containerNumber'
                },
                {
                    title: 'Keterangan',
                    key: 'description'
                },
                {
                    title: 'Nomor Giro',
                    key: 'giroNumber'
                },
                {
                    title: 'Tanggal Terima Giro',
                    key: 'giroDate'
                },
                {
                    title: 'Action',
                    key: 'action',
                    width: 150,
                    align: 'center',
                    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'success',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.showAddGiro(params.index)
                                    }
                                }
                            }, 'Tambah Giro')
                        ]);
                    }
                },
            ],
            receivableGiroData: [],
            isModalAddGiro: false,
            isLoadingAddGiro: false,
            bankAccounts: [],
            formAddGiro: {
                giroDate: '',
                giroNumber: '',
                giroNominal: '',
                paymentDate: '',
                bankAccountId: '',
            },
            ruleValidateGiro: {
                giroDate: [
                    { required: true, type: 'date', message: 'Pilih Tanggal Terima Giro', trigger: 'change' }
                ],
                giroNumber: [
                    { required: true, message: 'Masukkan Nomor Giro', trigger: 'blur' }
                ],
                giroNominal: [
                    { required: true, message: 'Masukkan Nominal Giro', trigger: 'blur' }
                ],
                paymentDate: [
                    { required: true, type: 'date', message: 'Pilih Tanggal Jatuh Tempo', trigger: 'change' }
                ],
                // bankAccountId: [
                //     { required: true, message: 'Pilih Bank', trigger: 'change' }
                // ]
            },
        }
    },
    methods: {
        getAllMarking: function() {
            this.isLoadingMarking = true;

            HTTP
            .get('marking/getAll')
            .then(response => {
                let data = response.data;
                let list = [];
                let comparer = '';

                for (let index = 0; index < data.length; index++) {
                    if (comparer == data[index].markingheaderid) {
                        continue;
                    }

                    let temp = {
                        value: data[index].markingheaderid,
                        label: data[index].markingheadercode
                    };

                    list.push(temp);
                    comparer = data[index].markingheaderid;
                }

                this.optionMarkings = list;
                this.isLoadingMarking = false;
            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })
        },
        getMarkingByCode: _.debounce(
            function (query) {
                if (query !== '') {
                    this.isLoadingMarking = true;
                    HTTP
                    .post('marking/getBySnapshot', {
                        markingHeaderId: query
                    })
                    .then(response => {
                        this.isLoadingMarking = false;
                        let data = response.data;

                        const list = data.map(item => {
                            return {
                                value: item.markingheaderid,
                                label: item.markingheadercode
                            };
                        });

                        this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                    })
                    .catch(e => {
                        this.isLoadingMarking = false;
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionMarkings = [];
                }
            }, 400
        ),
        showDateFormatted : function(stringToFormat){
            let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
            return moment(dateToFormat).format("DD MMM YYYY")
        },
        getReceivableGiro: function(){
            let parent = this;

            if(this.markingIdSelected == ''){
                return;
            }

            this.isLoadingMarking = true;

            HTTP.get('receivable/giro/' + this.markingIdSelected)
            .then(response => {
                let receivableGiro = []
                console.log({response});
                _.forEach(response.data, function(value, index) {
                    let invoiceDate = value.invoice != null ? parent.showDateFormatted(value.invoice.invoicedate) : ''
                    let containerNumber = value.invoice != null ? value.invoice.packaging_list.container_loading.containernumber : ''
                    let description = value.description
                    let giroDate = value.giro != null ? moment(value.giro.giroDate, 'YYYY-MM-DD hh:mm:ss').format("YYYY-MM-DD") : ''
                    let giroNumber = value.giro != null ? value.giro.giroNumber : ''
                    let giroNominal = value.giro != null ? value.giro.giroNominal : ''
                    let paymentDate = value.giro != null ? value.giro.paymentDate : ''
                    let bankAccountId = value.giro != null ? value.giro.bankAccountId : ''

                    let rGiro = {
                        receivableId : value.id,
                        markingHeaderId : value.markingHeaderId,
                        invoiceDate: invoiceDate,
                        containerNumber: containerNumber,
                        description: description,
                        giroDate: giroDate,
                        giroNumber: giroNumber,
                        giroNominal: giroNominal,
                        paymentDate: paymentDate,
                        bankAccountId: bankAccountId,
                    }
                    receivableGiro.push(rGiro);
                });

                this.receivableGiroData = receivableGiro;
                this.isLoadingMarking = false;
            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            });

        },
        getBankAccount: function() {
            HTTP.get("bankAccount/findAll/active")
            .then(response => {
                this.bankAccounts = response.data;
            })
            .catch(e => {
                this.$Notice.error({
                title: "Error",
                desc: e,
                duration: 5
                });
            });
        },
        showAddGiro: function(index){
            console.log("this.receivableGiroData : ", this.receivableGiroData);

            var receivableId = this.receivableGiroData[index].receivableId;
            var markingHeaderId = this.receivableGiroData[index].markingHeaderId;
            var invoiceDate = this.receivableGiroData[index].invoiceDate;
            var containerNumber = this.receivableGiroData[index].containerNumber;
            var giroDate = this.receivableGiroData[index].giroDate;
            var giroNumber = this.receivableGiroData[index].giroNumber;
            var giroNominal = this.receivableGiroData[index].giroNominal;
            var paymentDate = this.receivableGiroData[index].paymentDate;
            var bankAccountId = this.receivableGiroData[index].bankAccountId;

            this.formAddGiro.receivableId = receivableId;
            this.formAddGiro.markingHeaderId = markingHeaderId;
            this.formAddGiro.invoiceDateContainerNumber = invoiceDate + ' - ' + containerNumber;
            this.formAddGiro.giroDate = giroDate;
            this.formAddGiro.giroNumber = giroNumber;
            this.formAddGiro.giroNominal = giroNominal;
            this.formAddGiro.paymentDate = paymentDate;
            this.formAddGiro.bankAccountId = bankAccountId;

            this.isModalAddGiro = true;
        },
        postAddGiro: function(){
            this.isLoadingAddGiro = true;
            this.$Loading.start();

            let payload = {
                receivableId: this.formAddGiro.receivableId,
                markingHeaderId: this.formAddGiro.markingHeaderId,
                giroDate: this.summaryDate = moment(this.formAddGiro.giroDate, 'YYYY-MM-DD').format("YYYY-MM-DD"),
                giroNumber: this.formAddGiro.giroNumber,
                giroNominal: this.formAddGiro.giroNominal,
                paymentDate: moment(this.formAddGiro.paymentDate, 'YYYY-MM-DD').format("YYYY-MM-DD"),
                bankAccountId: this.formAddGiro.bankAccountId
            }

            console.log({payload});

            HTTP
            .post('giro/create', payload)
            .then(response => {
                console.log("post response :", response);

                this.isModalAddGiro = false;
                this.isLoadingAddGiro = false;
                this.$Loading.finish();
                this.$Message.success('Giro berhasil ditambahkan !');
                this.getReceivableGiro(this.markingIdSelected);
            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc:e,
                    duration: 5
                });
            })
        }
    },
    filters: {
        currency: function (value) {
            if (!value) return ''
            return numeral(value).format('0,0')
        }
    },
    mounted() {
        this.getBankAccount();
        this.$Loading.config({
            color: '#5cb85c',
            failedColor: '#f0ad4e',
            height: 10
        });
    }
}

</script>



// WEBPACK FOOTER //
// Giro.vue?00bedbfa